import { useEffect, useState } from "react";
import { Container } from '@mui/material';
import { NavLink, useParams } from "react-router-dom";

import { IMaterial } from "../../../types/material";

import { useUserContext } from "../../../contexts/userContext";
import { MaterialService } from "../../../services/materialService";

import PermissionGate from "../../permissionGate";
import Navigation from "../../header";
import MaterialDetailsForm from "../../forms/materialDetailsForm";

import Spinner from "../../spinner";
import { Icons } from "../../icons";

const MaterialEdit = () => {
	const userContext = useUserContext();
	let { id } = useParams();
	const [material, setMaterial] = useState<IMaterial>();
	const [isLoadingMaterial, setIsLoadingMaterial] = useState(true);

	useEffect(() => {
		getContainer();
	}, [])

	const getContainer = async () => {
		if (id) {
			MaterialService.getMaterial(id)
				.then((response) => {
					console.log('MaterialService.getMaterial: SUCCESS', response);
					setMaterial(MaterialService.mapMaterial(response.data));
				})
				.catch((error) => {
					console.log('MaterialService.getMaterial: ERROR', error);
				})
				.finally(() => {
					setIsLoadingMaterial(false);
				});
		}
	}

	return (
		<div className="hwi-material-edit">
			<Navigation></Navigation>
			<Container maxWidth="lg" className="route-container">
				<PermissionGate permission={userContext.permissions?.canManageCustomers}>
					<>
						<Spinner dependency={isLoadingMaterial} text="Loading material...">
							<section className="management-page-header">
								<div className="title">
									<NavLink to="/material">
										<Icons.GoBack fill="#9399ad" height="24px"></Icons.GoBack>
									</NavLink>
									{material?.material ?? "(Unnamed Material)"}
								</div>
							</section>
							<Spinner dependency={isLoadingMaterial} text="Loading material...">
								{material &&
									<MaterialDetailsForm action="edit" id={id!} details={material!} reloadData={getContainer}></MaterialDetailsForm>
								}								
							</Spinner>
						</Spinner>
					</>
				</PermissionGate>
				{/* <Json data={container}></Json> */}
			</Container>
		</div>
	);
};

export default MaterialEdit;
